import { render, staticRenderFns } from "./semifished-item-input.vue?vue&type=template&id=61e8fbf9&"
import script from "./semifished-item-input.vue?vue&type=script&lang=js&"
export * from "./semifished-item-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports